import React from 'react';

interface UserContextType {
  primaryMemory: any;
}

const UserDetailsContext = React.createContext<UserContextType | undefined>(undefined);

export default UserDetailsContext;